import type { IconName } from '@/shared/ui/Icon/Icon';
import type { SpritesMap } from '@/shared/ui/Icon/Icon.types';
import { SPRITES_META } from '@/shared/ui/Icon/Icon.types';

export const getIconMeta = <Key extends keyof SpritesMap>(name: IconName<Key>) => {
	const [spriteName, iconName] = name.split('/') as [Key, SpritesMap[Key]];

	const { filePath, items } = SPRITES_META[spriteName];

	const defaultSize = {
		height: 24,
		width: 24,
	};

	const viewBox = items[iconName]?.viewBox || '';

	return { defaultSize, filePath, iconName, viewBox };
};
